import { damageControlVisible as isDamageControlVisible } from "@/api/damageControl";

export default {
  computed: {
    damageControlCompany() {
      const getters = this.$store && this.$store.getters;
      return getters && getters.getCompany && getters.getCompany.company;
    },
    damageControlAvailable() {
      return isDamageControlVisible(this.damageControlCompany, this.isStaff);
    },
  },
};
